import { FormattedMessage } from 'react-intl';
import ScreenshotDialog from './ScreenshotDialog';
import CreateStepOne from '../createPartnerDialog/CreateStepOne';
import Button from '@rio-cloud/rio-uikit/Button';
import { ConnectionTypes } from '../../services/partnerNetwork.types';
import { useRestrictConnection } from '../../routes/routeHooks';

const ScreenshotOfAddPartner = () => {
    const defaultConnectionType = ConnectionTypes.ORDER_EXCHANGE;
    const restrictConnectionType = useRestrictConnection();

    return (
        <ScreenshotDialog
            title={<FormattedMessage id='intl-msg:network.addPartner.step1.title' />}
            buttons={
                <div className='btn-toolbar justify-content-end'>
                    <Button>
                        <FormattedMessage id='intl-msg:network.label.cancel' />
                    </Button>
                    <Button bsStyle={'primary'} className='btn-icon-right'>
                        <span className='rioglyph rioglyph-chevron-right' />
                        <FormattedMessage id='intl-msg:network.label.addPartner' />
                    </Button>
                </div>
            }
        >
            <CreateStepOne
                partnerName={undefined}
                onChangePartnerName={() => {}}
                partnerDescription={undefined}
                onChangePartnerDescription={() => {}}
                connectionType={defaultConnectionType}
                setConnectionType={() => {}}
                restrictConnectionType={restrictConnectionType}
                disableRadioButton={false}
            />
        </ScreenshotDialog>
    );
};

export default ScreenshotOfAddPartner;
